import * as validators from 'vuelidate/lib/validators';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';

const { valorUS } = FormatMixin.methods;

export const isCNPJ = (value) => {
  const cnpj = value.replace(/[^\d]+/g, '');
  return cnpj.length === 14;
};
export const requiredStringNumber = (value) => valorUS(value) > 0;
export const requiredIdProp = (prop) => {
  if (!prop) return false;
  return 'id' in prop;
};
export const requiredCalculationBasis = (value) => valorUS(value) >= 0;

export const { required, minLength, maxLength } = validators;
